import React, { useState } from 'react';
import { useUsersMeCached } from '@helloworld1812/hr-api';
import { FlexBox, Card, ButtonNew, message } from '@helloworld1812/ws-components';
import { Redirect, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useHrMutation } from '@/api';

import { NotificationConfigsSetupStep } from './notification-configs-setup-step';
import { DownloadAppStep } from './download-app-step';
import { S } from './user-onboarding-page.styled';
import {
  getWizardStepIndex,
  isValidOnboardingStep,
  OnboardingStep,
  onboardingPageSteps,
} from './user-onboarding-page.const';

export const UserOnboardingPage = () => {
  const { user, refetch: refetchUser, isFetching: isFetchingUser } = useUsersMeCached();
  const { t } = useTranslation('hr-account-routes');
  const history = useHistory();
  const [manuallySwitchStep, setManuallySwitchStep] = useState<OnboardingStep | undefined>(undefined);
  const { user_onboarding_desktop_step: onboardingStep } = user;

  const { mutateAsync: goToNextOnboardingStep, isLoading: isGoingToNextStep } = useHrMutation({
    url: '/v1/users/next_onboarding_step',
    method: 'post',
  });
  const currentStep = manuallySwitchStep ?? onboardingStep;

  const handleClickNext = async () => {
    try {
      const res = await goToNextOnboardingStep({
        data: {
          user_onboarding_desktop_step: currentStep,
        },
      });
      if (res.data.user_onboarding_desktop_step !== 'download_app') {
        history.push(res.data.user_onboarding_desktop_step === 'welcome_modal' ? '/job-postings' : '/');
      } else {
        setManuallySwitchStep('download_app');
      }
      refetchUser();
    } catch (error) {
      message.error(t('Failed to fetch next onboarding step. Please try again later.'));
    }
  };

  const isLoadingNext = isGoingToNextStep || isFetchingUser;

  if (!isValidOnboardingStep(currentStep)) {
    return <Redirect to="/" />;
  }

  return (
    <FlexBox column justify="center" align="flex-end" gap={8} width={800} mx="auto">
      <Card style={{ overflow: 'hidden' }} contentProps={{ px: 32, pt: 8, pb: 24, gap: 32 }} p={0}>
        <FlexBox mt={1} align="center">
          {onboardingPageSteps.map((step) => (
            <S.WizardStep key={step} $active={getWizardStepIndex(currentStep) >= getWizardStepIndex(step)} />
          ))}
        </FlexBox>

        {currentStep === 'notification' ? <NotificationConfigsSetupStep /> : <DownloadAppStep user={user} />}

        <FlexBox gap={8} justify="flex-end">
          {currentStep !== 'notification' && (
            <ButtonNew variant="secondary" size="compact" onClick={() => setManuallySwitchStep('notification')}>
              {t('Back')}
            </ButtonNew>
          )}
          <ButtonNew variant="primary" size="compact" onClick={handleClickNext} loading={isLoadingNext}>
            {t('Next')}
          </ButtonNew>
        </FlexBox>
      </Card>
    </FlexBox>
  );
};
